module.exports = __webpack_public_path__ + "img/logo0531.31795f02.svg";